import React, { useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { designColors } from "services/constants/designTokens";
import { PayrollSettingsHeader } from "./PayrollSettingsHeader";
import { SettingsBreadcrumbContext } from "pages/PayRoll/Shared/settingsBreadcrumb";
import { PayrollSettingsOverview } from "./PayrollSettingsOverview";
import { PayrollSetUp } from "./PayrollConfiguration";
import { ConfigPayInputConfiguration } from "./PayInputConfiguration";
import { ConfigStatutoryConfiguration } from "./StatutoryConfiguration";
import { ConfigDisbursementConfiguration } from "./DisbursementConfiguration";

// Payroll Settings (the "Settings" row at the bottom of the Payroll sidebar;
// see routes.js). On these pages the sidebar swaps the Payroll menu for the
// Payroll Settings menu (Sidebar/index.js, items in payrollSettingsMenu.js),
// and it opens on the Overview page (every settings page as a card). Each
// item has
// its own URL under /admin/payroll/configuration/<item>, matching this
// folder's sub-folders. Payroll Configuration is the existing Payroll setup
// screen (Payment Bank, Payrun Cycle, Payroll Group, Rounding Rules, Pay
// Slip, Daily Calculation Basis) with its own tab list; the
// Pay Input Configuration is built (one page per pay input, own sub-path);
// Disbursement is a "not implemented yet" placeholder.
export const CONFIGURATION_BASE_PATH = "/admin/payroll/configuration";

const CONFIGURATION_SCREENS = {
  overview: PayrollSettingsOverview,
  "pay-input-configuration": ConfigPayInputConfiguration,
  "statutory-configuration": ConfigStatutoryConfiguration,
  "payroll-configuration": PayrollSetUp,
  "disbursement-configuration": ConfigDisbursementConfiguration,
};

export const PayrollConfiguration = () => {
  const { pathname } = useLocation();
  // The open page hands its breadcrumb up so it shows at the top.
  const [trail, setTrail] = useState(null);
  let path = pathname;
  while (path.endsWith("/")) path = path.slice(0, -1);
  const segment = path.startsWith(`${CONFIGURATION_BASE_PATH}/`)
    ? path.slice(CONFIGURATION_BASE_PATH.length + 1).split("/")[0].toLowerCase()
    : "";
  const Screen = CONFIGURATION_SCREENS[segment];

  if (!Screen) {
    return (
      <Redirect to={`${CONFIGURATION_BASE_PATH}/overview`} />
    );
  }
  return (
    <SettingsBreadcrumbContext.Provider value={setTrail}>
      <Box sx={{ minWidth: 0, minHeight: "100%", backgroundColor: designColors.pageBg }}>
        <PayrollSettingsHeader trail={trail} showIntro={segment === "overview"} />
        <Box sx={{ minWidth: 0 }}>
          <Screen />
        </Box>
      </Box>
    </SettingsBreadcrumbContext.Provider>
  );
};
